export default class Login {
    static fromData(data) {
        if (!data) {
            return;
        }

        let login = new Login();
        login.username = data.username;

        Object.seal(login);

        return login;
    }
}
